import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { usePageTracking } from "@/hooks/usePageTracking";

// Original pages preserved — uncomment to restore the full site
// const Home = lazy(() => import("./pages/Home"));
// const Work = lazy(() => import("./pages/Work"));
// const Contact = lazy(() => import("./pages/Contact"));
// const NotFound = lazy(() => import("./pages/NotFound"));

const UnderConstruction = lazy(() => import("./pages/UnderConstruction"));

const queryClient = new QueryClient();

const AppWithTracking = () => {
  usePageTracking();
  return (
    <Suspense fallback={<div />}>
      <Routes>
        {/* Under construction — all routes show maintenance page */}
        <Route path="*" element={<UnderConstruction />} />
        {/* Original routes preserved — uncomment to restore:
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
        */}
      </Routes>
    </Suspense>
  );
};

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AppWithTracking />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
